import baseUrl from '../../utils/api';
import noCover from '@/assets/images/no-cover.png';

export default {
  name: 'goods',
  inject: ['reload'],
  data() {
    return {
      list: {
        items: [],
      },
      api: '',
      stage_tag_list: [],
      subject_tag_list: [],

      videoData: {
        show: false,
        title: '',
      },

      noCover,
      playData: '',

      listEnd: 0,

      showPay: false,
      getPayAbort: false,
      school_id: localStorage.getItem('school_id') || this.$store.state.choicesSchool.id,
    };
  },
  created() {
    this.api = `${baseUrl}/api/course/commodities?clients_id=${this.school_id}&equal[open_school_select]=1&open_school_id=${this.school_id}&equal[status]=1`;

    this.$http.get(`${baseUrl}/api/tags?order[order]=desc&equal[type]=stage`).then(res => this.stage_tag_list = res.items);

    this.$http.get(`${baseUrl}/api/tags?order[order]=desc&equal[type]=subject`).then(res => this.subject_tag_list = res.items);

    this.checkShowPay(this.$store.state.choicesSchool.main_id);
  },
  watch: {
    '$store.state.choicesSchool': function (val) {
      this.checkShowPay(val.main_id);
    },
  },
  methods: {
    // 教育平台 - 判断是否显示充值
    checkShowPay(main_id) {
      this.getPayAbort = false;

      if (this.$store.state.from === 'schoolCenter' && this.$permissions('school_teach_plat_classCenter_recharge')) {
        const nowDate = new Date();

        this.$http.get(`${baseUrl}/api/expense/main/${main_id}/detail/${nowDate.getFullYear()}-${1 + nowDate.getMonth()}`).then(() => {
          if (!this.getPayAbort) {
            this.showPay = true;
          }
        }).catch(() => {
          this.showPay = false;
        });
      } else {
        this.getPayAbort = true;
        this.showPay = false;
      }
    },

    // 显示视频
    showVideo(name, src) {
      this.videoData.title = name;
      this.videoData.src = src;
      this.videoData.show = true;
    },

    // 播放视频
    videoOpen() {
      this.$refs.ref_video.play();
    },

    // 关闭视频
    videoClose() {
      this.$refs.ref_video.pause();
    },

    // 课程详情
    showDetail(commodities_id) {
      sessionStorage.removeItem('class_detail_id');

      this.$router.push({
        path: '/goods/classDetail',
        query: {
          commodities_id,
        },
      });
    },
  },
  computed: {
    listLen() {
      !this.listEnd && this.list.items.length && (this.listEnd = this.list.items.length);

      return this.listEnd || /equal|like/.test(location.search);
    },
    searchArr() {
      return [
        {
          selectValue: this.stage_tag_list ? this.stage_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'stage_tag_id',
          label: this.$store.state.from === 'schoolCenter' ? '学生年级' : '',
        },
        {
          selectValue: this.subject_tag_list ? this.subject_tag_list.map(item => ({ value: item.id, name: item.name })) : [],
          componentType: 'AppSearchStatus',
          searchType: 'subject_tag_id',
          label: this.$store.state.from === 'schoolCenter' ? '学生科目' : '',
        },
        {
          componentType: 'AppSearchColumn',
          searchType: 'name',
          placeholder: '搜索商品名称',
        },
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/Goods/index.js